'use strict';

angular.module('sellers')
.directive('fileUpload', function() {
    return {
        templateUrl : "partials/file-upload.html",
        restrict: 'E', // attribute
        link : function (scope, element, attrs) {
            element.find('.trigger-upload').on('click', function(){
                element.find('#fileToUpload1').click();
            });
            element.find('#fileToUpload1').on('change', function() {
                var element = this;
                for(var i=0; i < scope.images.length; i++) {
                    scope.images.splice(i,1);
                }
                for (var i = 0; i < element.files.length; i++) {
                    scope.images.push({ file: element.files[i], name: element.files[i].name, uploadProgress: { percent: -1, label:'' } })
                }
                scope.$apply();
            });

            //removes images that not yet uploaded
            scope.removeFile = function(img) {
                if (scope.images.indexOf(img) > -1) {
                    scope.images.splice(scope.images.indexOf(img),1);
                }
            }
        }
    };
});